// global
var g;
if (typeof google !== 'undefined') {
  g = google.maps;
}

require('promise');
require('bxslider');
require('openlayers');

window._ = require('lodash');
window.moment = require('moment');
window.IH = require('ih/z.core');
window.IHChikatsuAsuka = require('ih/extend/IHChikatsuAsuka');




// WEBPACK FOOTER //
// ./map/js/main.js